/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Desktop Filters In Stock Availability
(function () {
  let isBound = false;

  function handleSizeFilterClick(event) {
    const target = event.target;

    if (target.matches('input[name="filter.v.option.size"]')) {
      const availabilityInput = document.querySelector(
        'input[name="filter.v.availability"][value="1"]'
      );

      if (target.checked && availabilityInput && !availabilityInput.checked) {
        availabilityInput.checked = true;
      }
    }
  }

  function bindFilterAvailabilityHandler() {
    const filtersContainer = document.querySelector("body");

    if (!filtersContainer || isBound) return;

    filtersContainer.addEventListener("click", handleSizeFilterClick);
    isBound = true;
  }

  function watchFiltersContainer() {
    const observerTarget = document.querySelector("body")?.parentNode;

    if (!observerTarget) return;

    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList") {
          isBound = false;
          bindFilterAvailabilityHandler();
        }
      }
    });

    observer.observe(observerTarget, {
      childList: true,
      subtree: true,
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    bindFilterAvailabilityHandler();
    watchFiltersContainer();
  });
})();

// Mobile Filters In Stock Availability to handle fact that the filters are dynamically added to DOM when clicking the filter button
(function () {
  const observerTarget = document.querySelector("body");

  if (!observerTarget) return;

  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (
        mutation.type === "attributes" &&
        mutation.target.classList.contains("js-collection-draw-open")
      ) {
        const sizeFilterInputs = document.querySelectorAll(
          'input[name="filter.v.option.size"]'
        );
        const availabilityInput = document.querySelector(
          'input[name="filter.v.availability"][value="1"]'
        );

        sizeFilterInputs.forEach((sizeInput) => {
          if (
            sizeInput.checked &&
            availabilityInput &&
            !availabilityInput.checked
          ) {
            availabilityInput.checked = true;
          }
        });
      }
    }
  });

  observer.observe(observerTarget, {
    attributes: true,
    attributeFilter: ["class"],
  });
})();
